import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"

import { getVerticalSigningLegendConfig } from "../constants/verticalSigningConditions"

export function useVerticalSigningLegend() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    return [
        {
            layerName: "verticalSigning",
            legendData: getVerticalSigningLegendConfig(t, theme),
            title: t(I18N_NAMESPACE, "containers.verticalSign.legend.title"),
        },
    ]
}